import {
  fetchGetApiIntroducerPortalIntroducerNotification,
  fetchGetApiIntroducerPortalIntroducerNotificationSubscription,
} from '@iwoca/lapi-client/introducer_portal';
import {
  TNotification,
  TNotificationSubscription,
  patchAllNotifications,
  patchNotification,
  patchSubscriptions,
} from 'lendingApi/notifications';

type TFormattedNotificationsPayload = {
  data: TNotification[];
  nextPage: number | undefined;
  total?: number;
  pages?: number;
  totalUnseen?: number;
};

export async function getNotifications(
  introducerId: string,
  pageNo = 1,
): Promise<TFormattedNotificationsPayload> {
  const {
    data: { notifications, next_page, results, pages, unread_notifications },
  } = await fetchGetApiIntroducerPortalIntroducerNotification({
    introducerId,
    query: {
      //@ts-ignore
      page_no: pageNo,
      per_page: 5,
    },
  });

  return {
    data: notifications,
    nextPage: next_page || undefined,
    total: results,
    totalUnseen: unread_notifications,
    pages,
  };
}

export function markNotificationAsRead(
  introducerId: string,
  applicationId: string,
  notificationId: string,
): Promise<{ data: { [key: string]: string } }> {
  // TODO: Replace the below function with the one from the lapi module when fixed.
  return patchNotification(introducerId, applicationId, notificationId, {
    read: true,
  });
}

export function markAllNotificationsAsRead(
  introducerId: string,
): Promise<{ data: { [key: string]: string } }> {
  return patchAllNotifications(introducerId, { read: true });
}

export async function getNotificationSubscriptions(
  introducerId: string,
): Promise<TNotificationSubscription[]> {
  const { data } =
    await fetchGetApiIntroducerPortalIntroducerNotificationSubscription({
      introducerId,
    });

  return data;
}

export function updateNotificationSubscriptions(
  introducerId: string,
  newSubscriptions: TNotificationSubscription[],
): Promise<{ data: { [key: string]: string } }> {
  return patchSubscriptions(introducerId, newSubscriptions);
}
